<div class="container">
  <div class="header">
    <mat-icon class="header-icon">qr_code_scanner</mat-icon>
    <h2>Punkte empfangen</h2>
    <p class="subtitle" *ngIf="scannerEnabled">
      Bitte scanne den QR-Code des Users von dem du Punkte einsammeln möchtest.
    </p>
  </div>

  <mat-card class="scanner-card" *ngIf="scannerEnabled">
    <mat-card-content>
      <div class="scanner-wrapper">
        <zxing-scanner
          #scanner
          class="scanner"
          [enable]="scannerEnabled"
          [autostart]="true"
          (camerasFound)="camerasFoundHandler($event)"
          (camerasNotFound)="camerasNotFoundHandler($event)"
          (scanSuccess)="scanSuccess($event)"
          (scanFailure)="scanFailure($event)"
          (scanError)="scanError($event)"
          (scanComplete)="scanComplete($event)"
          (deviceChange)="deviceHasChanged($event)"
          [formats]="['QR_CODE']"
          [timeBetweenScans]="2000"
          [delayBetweenScanSuccess]="2000"
        ></zxing-scanner>
      </div>
    </mat-card-content>
    <mat-card-actions class="scanner-actions" *ngIf="camInitialized">
      <button mat-button (click)="changeCamera()">
        <mat-icon>cameraswitch</mat-icon>
        Kamera wechseln
      </button>
      <button mat-button (click)="showInfoDialog()">
        <mat-icon>help_outline</mat-icon>
        Hilfe
      </button>
    </mat-card-actions>
  </mat-card>

  <div class="enable-cam" *ngIf="!scannerEnabled && camInitialized">
    <mat-icon class="cam-off-icon">videocam_off</mat-icon>
    <p class="cam-off-text">Kamera ist deaktiviert</p>
    <button mat-raised-button color="primary" class="enable-cam-btn" (click)="enableCamera()">
      <mat-icon class="enable-cam-btn-icon">videocam</mat-icon>
      Kamera aktivieren
    </button>
  </div>
</div>

<button
  *ngIf="userSpecificFinishedTransfers.length > 0"
  mat-fab
  class="history-btn"
  color="primary"
  aria-label="Punkte-Historie"
  (click)="showPointsHistory()"
>
  <mat-icon class="history-icon">history</mat-icon>
</button>
